<template>
  <div class="page flex-col">
    <van-cell-group>
    <p class="text3Indentation">
      <van-steps :active="activeAll">
        <van-step>机构邀请</van-step>
        <van-step>个人信息</van-step>
        <van-step>补充调研</van-step>
      </van-steps>
    </p>
  </van-cell-group>
    <div class="group_2 flex-col">
      <van-divider
        :style="{ color: '#fa8a19', borderColor: '#fa8a19', padding: '0 16px' }">个人绑定信息</van-divider
      >
      <van-tabs v-model:active="active">
        <van-tab title="预留信息绑定">
          <van-form>
            <br/>
            <van-cell-group inset>
              <van-notice-bar
                scrollable
                left-icon="volume-o"
                text="请输入您在该机构检查时留下的个人信息！已经核验通过的申请，再次修改请联系机构人员"
              />
              <van-field
                v-model="registerData.realName"
                required
                label="真实姓名"
                :rules="[{ required: true, message: '请填写姓名' }]"
              />
              <van-field
                v-model="registerData.phone"
                required
                label="手机号码"
                :rules="[
                  { required: true },
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '手机号码格式错误！',
                  },
                ]"
              />
              <van-field
                v-model="registerData.idCard"
                required
                label="身份证"
                :rules="[{ required: true, message: '请填写手机号' }]"
              />
            </van-cell-group>
          </van-form>
          <div style="margin: 16px">
            <van-button
              round
              block
              color="linear-gradient(to right, #f67f34, #d55809)"
              native-type="submit"
              @click="getData">下一步</van-button>
          </div>
          <span class="text_3"></span>
      <div class="image-text_1 flex-col">
        <span class="text-group_1"></span>
      </div>
      <div class="group_3 flex-col">
        <div class="text-group_2 flex-col">
        </div>
      </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import { postHospAndMobile } from "../../api/register";
import { postUserLog } from "../../api/userlog";
import { useRouter } from "vue-router";
import { showDialog } from "vant";
export default {
  setup() {
    const showBinging = ref(false);
    const activeAll = ref(1);
    const active = ref(0);
    const router = useRouter();
    const ulog = reactive({
      UserLog: {
        path: "",
      },
    });
    const kpianawait = reactive({
      cellGroupBackground: "#F1F1F1",
    });
    const state = reactive({
      registerData: {
        hospitalName: "",
        hospitalCode: "",
        realName: "",
        nowHospName: "",
        nowHospCode: "",
        phone: "",
        idCard: "",
        smsBindingCode: "",
        informed: "",
        isDoctor: "",
        pageTabId: "1",
      },
    });
    const hosp = reactive({
      HospInfo: {
        hospId: "",
      },
    });
    const getData = () => {
      console.log(state.registerData.realName);
      if (state.registerData.realName == ""|| state.registerData.phone ==""|| state.registerData.idCard =="") {
        showDialog({
            title: "错误提醒",
            message: "请填写必要的绑定信息!",
            theme: "round-button",
          }).then(() => {
            
          });
      } else {
        postHospAndMobile(state.registerData).then((res) => {
          console.log(res);
          if (res.data.code == 20000) {
            console.log("绑定成功");
            router.push('bindingStepHosp2');
          } else {
            showDialog({
              title: "错误提醒",
              message: res.data.message,
              theme: "round-button",
            }).then(() => {
            
            });
          }
        });
      }
    };
    onMounted(() => {
      console.log("页面打开");
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
    });
    return {
      hosp,
      kpianawait,
      ...toRefs(state),
      getData,
      showBinging,
      activeAll,
      active,
   
    };
  },
};
</script>
<style scoped lang="css" src="./assets/index.css" />
